import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PdfViewerModule} from 'ng2-pdf-viewer';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatDividerModule} from '@angular/material/divider';
import {MatSidenavModule} from '@angular/material/sidenav';
import {FlexLayoutModule} from '@angular/flex-layout';

import {InvoiceVisualisingRoutingModule} from './invoice-visualising-routing.module';
import {InvoiceVisualisingComponent} from './invoice-visualising.component';


@NgModule({
    declarations: [InvoiceVisualisingComponent],
    imports: [
        CommonModule,
        InvoiceVisualisingRoutingModule,
        MatButtonModule,
        MatSidenavModule,
        MatIconModule,
        MatTooltipModule,
        MatDividerModule,
        FlexLayoutModule,
        PdfViewerModule
    ], exports: [
        InvoiceVisualisingComponent
    ]
})
export class InvoiceVisualisingModule {
}
